module.exports = __webpack_public_path__ + "fonts/3220473.ttf";